var map = {
	"./burger_icon.svg": 1120,
	"./camp.svg": 1356,
	"./creative.svg": 1357,
	"./cross.svg": 1121,
	"./earth_group.svg": 1358,
	"./feature_1.svg": 1359,
	"./feature_2.png": 1145,
	"./feature_2.svg": 1360,
	"./feature_3.svg": 1361,
	"./flag.svg": 1168,
	"./frontend.svg": 1362,
	"./gamedesign.svg": 1363,
	"./graphicdesign.svg": 1364,
	"./junior.svg": 1365,
	"./map_yellow.svg": 1167,
	"./math_circles_bg.svg": 1366,
	"./math_circles_bg_sm.svg": 1367,
	"./math_courses_1.svg": 1368,
	"./math_courses_2.svg": 1369,
	"./math_road_line_1.svg": 1152,
	"./math_road_line_2.svg": 1153,
	"./math_road_line_3.svg": 1154,
	"./math_road_line_4.svg": 1155,
	"./maths_logo.svg": 1370,
	"./maths_logo_white.svg": 1371,
	"./pc.svg": 1372,
	"./programming_bg.svg": 1301,
	"./programming_bg_sm.svg": 1302,
	"./programming_comment_1.svg": 1140,
	"./programming_comment_2.svg": 1141,
	"./programming_comment_3.svg": 1142,
	"./programming_logo-en.svg": 1134,
	"./programming_logo-ru.svg": 1133,
	"./programming_logo_white.svg": 1132,
	"./programming_puzzles.svg": 1131,
	"./programming_square.svg": 1184,
	"./programming_summer.svg": 1373,
	"./pytpro.svg": 1374,
	"./pytstart.svg": 1375,
	"./school.svg": 1169,
	"./share_icon_violet.svg": 1185,
	"./share_icon_white.svg": 1143,
	"./smile.svg": 1170,
	"./tg_logo.svg": 1119,
	"./tg_logo_white.svg": 1123,
	"./unity.svg": 1376,
	"./videocontent.svg": 1377,
	"./websites.svg": 1378,
	"./whats_logo.svg": 1118,
	"./whats_logo_white.svg": 1122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1355;